import React, { useEffect, useMemo, useState } from 'react';
import {
  XMarkIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from '@heroicons/react/24/outline';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Keyboard } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const clamp = (n, min, max) => Math.max(min, Math.min(n, max));

const CustomMediaModal = ({
  isOpen,
  onClose,
  images = [],
  initialIndex = 0,
}) => {
  const safeImages = useMemo(
    () => (Array.isArray(images) ? images.filter(Boolean) : []),
    [images]
  );

  const safeStart = clamp(initialIndex, 0, Math.max(0, safeImages.length - 1));
  const [, setActiveIdx] = useState(safeStart);

  useEffect(() => {
    if (isOpen) setActiveIdx(safeStart);
  }, [isOpen, safeStart]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center backdrop-blur-md bg-black/80">
      <div className="relative w-full max-w-6xl mx-auto px-4 py-8">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-20 text-white hover:text-yellow-400 transition"
          aria-label="Close"
          type="button"
        >
          <XMarkIcon className="w-8 h-8" />
        </button>

        <Swiper
          key={`${safeImages.length}-${safeStart}`}
          modules={[Navigation, Pagination, Keyboard]}
          initialSlide={safeStart}
          onSlideChange={(s) => setActiveIdx(s.realIndex)}
          keyboard={{ enabled: true }}
          navigation={{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }}
          pagination={{
            el: '.swiper-pagination',
            clickable: true,
          }}
          spaceBetween={30}
          slidesPerView={1}
          className="rounded-xl overflow-hidden"
        >
          {safeImages.map((src, idx) => (
            <SwiperSlide key={`${src}-${idx}`}>
              <div className="flex justify-center items-center w-full h-[70vh]">
                <img
                  src={src}
                  alt={`Slide ${idx + 1}`}
                  className="max-h-full max-w-full object-contain shadow-lg"
                  loading="lazy"
                  draggable={false}
                />
              </div>
            </SwiperSlide>
          ))}

          {safeImages.length > 1 && (
            <>
              <div className="swiper-button-prev absolute left-2 top-1/2 -translate-y-1/2 z-20 cursor-pointer rounded-full p-2">
                <ChevronLeftIcon className="w-8 h-8 text-white" />
              </div>
              <div className="swiper-button-next absolute right-2 top-1/2 -translate-y-1/2 z-20 cursor-pointer rounded-full p-2">
                <ChevronRightIcon className="w-8 h-8 text-white" />
              </div>
            </>
          )}

          {safeImages.length > 1 && (
            <div className="swiper-pagination !bottom-4"></div>
          )}
        </Swiper>
      </div>
    </div>
  );
};

export default CustomMediaModal;
